import React from 'react';
import { Box, Typography } from '@mui/material';

export const Label = ({ label, classes }) => (
  <Box display="flex" flexDirection="row" alignItems="center">
    <Typography className={classes.label}>{label}</Typography>
  </Box>
);

Label.displayName = 'Label';
